import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59910f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = { class: "view-group-box" }
const _hoisted_3 = { style: {"height":"500px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_ui_layout1 = _resolveComponent("ui-layout1")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!
  const _component_ui_editor = _resolveComponent("ui-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ui_layout1, {
        title: "左右间隔",
        class: "view-item-box"
      }, {
        content: _withCtx(() => [
          _createVNode(_component_el_slider, {
            modelValue: _ctx.modelValue.gap,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.gap) = $event)),
            "show-input": "",
            class: "slider-style-box",
            "show-input-controls": false
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ui_layout2, {
      title: "背景颜色",
      ext: _ctx.modelValue.style.backgroundColor
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "text",
          style: {"margin":"0 10px 0 0"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
        _ctx.modelValue.style.backgroundColor = _ctx.defaultData.data.style.backgroundColor
        ))
        }, {
          default: _withCtx(() => [
            _createTextVNode("重置")
          ]),
          _: 1
        }),
        _createVNode(_component_el_color_picker, {
          modelValue: _ctx.modelValue.style.backgroundColor,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.style.backgroundColor) = $event)),
          onActiveChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.style.backgroundColor = $event)),
          "show-alpha": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["ext"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ui_editor, {
        style: {"height":"100%"},
        modelValue: _ctx.modelValue.content,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.content) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}